/**
 * UUID Generation Utility
 *
 * Uses expo-crypto for consistent UUID generation across all platforms.
 * expo-crypto works on web, iOS, and Android.
 */

import * as Crypto from "expo-crypto";

/**
 * Generates a UUID v4 string using expo-crypto
 *
 * Works consistently across all platforms (web, iOS, Android).
 * @returns UUID v4 string
 * @example
 * ```typescript
 * import { generateUUID } from "@/utils/uuid";
 *
 * const sessionId = generateUUID();
 * console.log(sessionId); // "550e8400-e29b-41d4-a716-446655440000"
 * ```
 */
export const generateUUID = (): string => Crypto.randomUUID();
